<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-06-20 10:46:07
-->
<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		size="600px"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		class="custom-template"
	>
		<div class="pt-20 pb-20 pl-16 pr-16 radius-8 yx-background-white">
			<div class="label mb-24 font-h3-regular font-bold">
				<span class="ml-12">设置筛选条件明细</span>
			</div>
			<el-form :model="form" ref="form" :label-width="labelWidth" :label-position="labelPosition">
				<el-form-item :label="item.label" :prop="item.key" v-for="item in dynamicsList" :key="item.key">
					<component
						:is="item.component"
						v-model="form[item.key]"
						:collapseTags="item.collapseTags"
						:multiple="item.multiple"
						:returnArray="true"
						v-if="item.component"
						:size="item.size"
						style="width: 100%"
						@settingPlatform="settingPlatform"
						:platformId="selectPlatformId"
						:key="item.isConcact ? selectPlatformId : ''"
						:showAll="item.showAllPlatform"
					/>
					<el-select
						style="width: 100%"
						:multiple="item.multiple"
						:clearable="item.clearable"
						:filterable="item.filterable"
						v-model="form[item.key]"
						:placeholder="item.placeholder"
						v-else-if="item.type === 'select'"
					>
						<el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
					<el-radio-group v-model="form[item.key]" v-else-if="item.type === 'radio'">
						<el-radio v-for="row in item.options" :key="row.value" :label="row.value">{{ row.label }}</el-radio>
					</el-radio-group>
					<el-input style="width: 100%" v-model="form[item.key]" :placeholder="item.placeholder" v-else></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="confirm" :loading="loading">确认</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { debounce } from 'lodash';
import { setFieldShow } from '@/api/common';
export default {
	props: {
		labelWidth: {
			type: String,
			default: '120px',
		},
		labelPosition: {
			type: String,
			default: 'left',
		},
		platformId: {
			type: [Number, String],
			default: +dataMap.PLATFORM_DY.value,
		},
		listType: {
			type: String,
			default: '',
		},
		dynamicsList: {
			type: Array,
			default: () => [],
		},
		defaultForm: {
			type: Object,
			default: () => ({}),
		},
	},
	watch: {
		platformId: {
			handler(val) {
				this.selectPlatformId = val;
			},
			immediate: true,
		},
	},
	data() {
		return {
			title: '设置默认筛选条件', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			appendToBody: true,
			wrapperClosable: false,
			form: {},
			selectPlatformId: '',
		};
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(val = {}, isEdit) {
			if (isEdit) {
				this.form = { ...val, ...this.defaultForm };
			} else {
				this.form = { ...this.defaultForm };
			}
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.$refs.form.resetFields();
			this.form = {};
			// 关闭弹窗
			this.visible = false;
		},
		settingPlatform(val) {
			this.form.authority_id = '';
			this.selectPlatformId = val;
		},
		// 确认按钮点击事件
		confirm: debounce(async function () {
			const { listType, form: show_head_list, platformId } = this;
			// console.log('show_head_list', show_head_list);
			// 按钮loading开启
			this.loading = true;
			try {
				// 刷新列表（外部重新获取数据）
				await setFieldShow({ list_type: `${listType}${platformId}`, show_head_list });
				this.$message.success('设置成功');
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
	},
	components: {},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.custom-template {
	.label {
		position: relative;

		&::before {
			content: '';
			position: absolute;
			left: 0px;
			top: 4px;
			width: 3px;
			height: 17px;
			border-radius: 2px;
			background-color: @color-primary;
		}
	}
	/deep/ .el-drawer__body {
		padding: 16px 16px 65px !important;
		background-color: #f7f8f9;
		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	.drawer-footer {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		padding: 16px;
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid @color-gy3;
		background-color: @color-gy1;
	}
}
</style>
